// extracted by mini-css-extract-plugin
module.exports = {"form":"PasswordResetPage_form__2A9Pj","link":"PasswordResetPage_link__36VXg","error":"PasswordResetPage_error__3x789"};